export default __webpack_public_path__ + "static/kb_3_13-98b520199df45e01d5284e0753ba38c3.jpg";